module.exports = __webpack_public_path__ + "img/1525937389.0927d33d.jpg";